import { Box } from "@mui/material"
import { InventoryCard } from "./inventory-card"
import { ReadonlyUOM } from "./readonly-uom"

export function UomInventoryRow({ uom }) {
    return (
        <Box my={1}>
            <InventoryCard sx={{ backgroundColor: "background.neutral" }} isSynced={false}>
                <ReadonlyUOM uom={uom} />
            </InventoryCard>
        </Box>
    )
}
